import { gql } from "@apollo/client";

export const LIST_QUEUE_RECORDS_QUERY = gql`
  query ListQueueRecords($limit: Int, $nextToken: String) {
    listQueueRecords(limit: $limit, nextToken: $nextToken) {
      messages {
        id
        name
        status
        createdAt
        updatedAt
        data
        messageId
        receiptHandle
        body
        attributes
      }
      nextToken
    }
  }
`;
